import { HStack, VStack, Text, Box } from '@cad-arc';
import React from 'react';
import { AdditionalInfoType } from '../types';
import AdditionalInfoRenderer from '../additional-info-renderer/additional-info-renderer';
import { AdditionalInfoRow } from '../components/additional-info-row';
import { UnreadButton } from '../components/unread-button';
import { AdditionalInfosStoreProvider } from '../hooks/use-additional-infos/additional-infos-provider';
import styles from '../components/narrative-panel.module.css';

/* eslint-disable-next-line */
export interface ProQaAdditionalInfosProps {
    agencyEventId: number;
    agencyEventNumber: string;
    markVisibleInfosAsRead: boolean;
    currentUserId: number;
    /**
     * The ProQA title shows by default,
     * but consumers can optionally hide this title text
     */
    hideTitle?: boolean;
}

export function ProQaAdditionalInfos({
    agencyEventId,
    agencyEventNumber,
    markVisibleInfosAsRead,
    currentUserId,
    hideTitle,
}: ProQaAdditionalInfosProps): React.JSX.Element {
    return (
        <AdditionalInfosStoreProvider
            entityId={agencyEventId}
            entityNumber={agencyEventNumber}
            initialFilter={[AdditionalInfoType.PROQA]}
            eventOptions={{ includeEventNarratives: false }}
            currentUserId={currentUserId}
        >
            <VStack align="stretch" height="100%">
                {!hideTitle && (
                    <Box className={styles['margin-right']}>
                        <HStack justify="space-between">
                            <Text className={styles['event-panel-section-heading']}>ProQA</Text>
                        </HStack>
                    </Box>
                )}
                <AdditionalInfoRenderer
                    rowComponent={AdditionalInfoRow}
                    addonComponent={UnreadButton}
                    markVisibleAsRead={markVisibleInfosAsRead}
                />
            </VStack>
        </AdditionalInfosStoreProvider>
    );
}

export default ProQaAdditionalInfos;
